"use strict";

module.exports = "\n<svg class=\"bvp-icon play\" viewBox=\"-4 0 22 22\">\n  <path d=\"M17.446 11.966L1.701 21.348A1.125 1.125 0 0 1 0 20.38V1.618A1.125 1.125 0 0 1 1.7.652l15.746 9.381a1.125 1.125 0 0 1 0 1.933z\" fill=\"#FFF\" fill-rule=\"evenodd\"/>\n</svg>\n";